import { render, staticRenderFns } from "./peace.vue?vue&type=template&id=4eae4845&scoped=true"
import script from "./peace.vue?vue&type=script&lang=js"
export * from "./peace.vue?vue&type=script&lang=js"
import style0 from "./peace.vue?vue&type=style&index=0&id=4eae4845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eae4845",
  null
  
)

export default component.exports